<template>
    <div class="flex flex-column justify-content-start gap-2 ">
        <div class="flex flex-column justify-content-start gap-2 pb-2 ">
            <span class="note-title">{{ note.title }}</span>
            <span class="Paragraph-Medium"> {{ note.subject }}</span>
            <span class="Paragraph-Medium pb-4"> {{ formatToDisplayDate(note.created_at) }}</span>
            <div class="Label note-text" v-html="note.note"></div>
        </div>
        <div class="flex  flex-wrap justify-content-start gap-2 py-4">
            <Button label="Edit Note" class="orange-button-small" @click="$emit('edit-note', note)" />
            <Button label="Delete Note" class="p-button-outlined p-button-danger" @click="removeNote" />
        </div>
        <ConfirmDialog></ConfirmDialog>
    </div>
</template>
<script setup>
import { defineProps, defineEmits } from "vue";
import Button from "primevue/button";
import { formatToDisplayDate } from "@/utils/cleanups";
import { ConfirmDialog } from "primevue";
import { useConfirm } from "primevue/useconfirm";
import { deleteNote } from "@/api/student";

const confirm = useConfirm();
const props = defineProps({
    note: {
        type: Object,
        required: true
    }
});
const emit = defineEmits(['edit-note', 'refresh-notes']);
const removeNote = () => {
    confirm.require({
        message: 'Do you want to delete this note?',
        header: 'Danger Zone',
        icon: 'pi pi-info-circle',
        rejectLabel: 'Cancel',
        rejectProps: {
            label: 'Cancel',
            severity: 'secondary',
            outlined: true
        },
        acceptProps: {
            label: 'Delete',
            severity: 'danger'
        },
        accept: async () => {
            await deleteNote(props.note._id);
            emit('refresh-notes');
        },
    });
}
</script>
<style scoped>
.p-button-danger {
    padding: 8px 16px 8px 16px;
    height: 34px;
    font-size: 0.75rem;
}

.teal-button {
    padding: 10px 16px 10px 16px;
    height: 30px;
    font-size: 0.75rem;
}

.note-title {
    font-size: 1.1rem;
    font-weight: 600;
    line-height: 130%;
    letter-spacing: 0.3px;
    display: block;
    padding-bottom: 0.5rem;
    text-align: left;
    color: black;
}

.note-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
}
</style>